import { SET_SCALE } from '../actions/types';
import { setter } from './utils';

export default setter(SET_SCALE, 0);
